<div class="progress-countdown">
  <div class="anim">
    <svg class="circle-outer" viewBox="0 0 86 86">
      <circle class="back" cx="43" cy="43" r="40"></circle>
      <circle class="front" cx="43" cy="43" r="40"></circle>
      <circle class="new" cx="43" cy="43" r="40"></circle>
    </svg>
    <svg class="circle-middle" viewBox="0 0 60 60">
      <circle class="back" cx="30" cy="30" r="27"></circle>
      <circle class="front" cx="30" cy="30" r="27"></circle>
    </svg>
    <svg class="circle-inner" viewBox="0 0 34 34">
      <circle class="back" cx="17" cy="17" r="14"></circle>
      <circle class="front" cx="17" cy="17" r="14"></circle>
    </svg>
  </div>
  <div *ngIf="text" class="text text-small">{{ text }}</div>
  <div *ngIf="!countdown" class="text text-small">
    {{ 'touareg.waiting' | translate }}
  </div>
  <strong *ngIf="!!countdown" class="counter">{{ countdown }}</strong>
</div>
